export const parseParams = (querystring: string): Record<string, string | string[] | null> => {
  const obj: Record<string, string | string[] | null> = {};

  if (!querystring.startsWith("?")) {
    return obj;
  }

  const params = new URLSearchParams(querystring);

  for (const key of params.keys()) {
    if (params.getAll(key).length > 1) {
      obj[key] = params.getAll(key);
    } else {
      obj[key] = params.get(key);
    }
  }

  return obj;
};

/**
 * Hosts on which CX runs locally or in a dev environment.
 * Used to enable local-development-only behaviors (e.g. impersonation bridge,
 * suppressing the internal-user redirect hook).
 */
export const localCxHosts = new Set(["localhost", "127.0.0.1", "dev.one.shi.com"]);

/** Returns true when CX is running on a local/dev host. */
export function isLocalCxHost(hostname = window.location.hostname): boolean {
  return localCxHosts.has(hostname);
}
